const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreen1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFEDB5"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEE187"
    },
    d: "M505.601,313.099L359.015,166.514l-126.236,126.05l-88.047,86.357l132.222,132.222 C389.31,502.039,481.156,420.395,505.601,313.099z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8BC180"
    },
    d: "M152.657,382.204c-2.869,0-5.735-1.095-7.925-3.282c-4.375-4.375-4.375-11.469,0.002-15.846 l104.512-104.51c4.374-4.375,11.469-4.374,15.846,0.002c4.375,4.375,4.375,11.469-0.002,15.846l-104.512,104.51 C158.392,381.109,155.524,382.204,152.657,382.204z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6CAF5F"
    },
    d: "M265.092,258.565c4.375,4.375,4.375,11.469-0.002,15.846l-104.512,104.51 c-2.188,2.188-5.056,3.281-7.923,3.281c-2.869,0-5.735-1.095-7.925-3.282L265.092,258.565z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B9B27"
    },
    d: "M187.975,214.652c47.611-47.538,171.041-48.138,171.041-48.138s-0.783,123.428-48.393,170.967 s-90.152,35.106-124.02,1.188S140.366,262.191,187.975,214.652z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E821A"
    },
    d: "M359.015,166.514c0,0-0.783,123.428-48.393,170.967s-90.152,35.106-124.02,1.188L359.015,166.514z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreen1);
export default __webpack_public_path__ + "static/media/green-1.b29bcbcd96ad58473a627461c29740b6.svg";
export { ForwardRef as ReactComponent };